import React from "react";
import { Grid } from "@mui/material";
import { startCase } from "lodash";
import LabeledText from "../../Widgets/LabeledText";
import { InterventionHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: InterventionHistoryFormValues;
}

const formatEnum = (value: string | null | undefined): string =>
  value ? startCase(value.toLowerCase()) : "-";

const formatEnumArray = (values: string[]): string =>
  values.length > 0 ? values.map((v) => startCase(v.toLowerCase())).join(", ") : "-";

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Has the client ever received ABA therapy in the past?"
        value={formatEnum(formValues.hasReceivedServices)}
      />
      {formValues.hasReceivedServices === "YES" && (
        <LabeledText
          label="Why were previous ABA therapy services discontinued?"
          value={formValues.previousServicesDiscontinuationReason || "-"}
        />
      )}
      <LabeledText
        label="Specific barriers preventing the client from accessing services"
        value={formatEnumArray(formValues.accessBarriers)}
      />
    </Grid>
  );
};

export default ViewFields;
